var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"item-loading"},[_c('div',{staticClass:"skeleton-shimmer bg"}),_c('div',{staticClass:"bottom"},[_c('div',{staticClass:"skeleton-shimmer text"}),_c('div',{staticClass:"skeleton-shimmer btn"})])])
}]
render._withStripped = true
export { render, staticRenderFns }